export const updateJobCampaign = `mutation UpdateJob($input: UpdateJobInput!) {
    updateJob(input: $input) {
      id
    campaignId
    title
    referralBonus
    }
  }
  `;
